module.exports = __webpack_public_path__ + "img/business-building.6bb859e0.jpg";